@use "@/styles/variables" as *;

.container {
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 2px;
	min-width: 0;
}

.heroCard {
	position: relative;
	border: 1px solid $gray-200;
	border-radius: 12px;
	padding: 14px 16px;
	background: linear-gradient(145deg, #ffffff 0%, #fcfdf8 65%, #f8fbf0 100%);
	overflow: hidden;

	&::after {
		content: "";
		position: absolute;
		right: -30px;
		top: -35px;
		width: 120px;
		height: 120px;
		border-radius: 999px;
		background: radial-gradient(circle, rgba(127, 176, 47, 0.22) 0%, rgba(127, 176, 47, 0.02) 65%, transparent 100%);
		pointer-events: none;
	}
}

.heroBadge {
	display: inline-flex;
	align-items: center;
	font-size: 0.6875rem;
	font-weight: 700;
	color: $primary-color;
	background: rgba(127, 176, 47, 0.12);
	border: 1px solid rgba(127, 176, 47, 0.25);
	border-radius: 999px;
	padding: 4px 8px;
	margin-bottom: 8px;
	text-transform: uppercase;
	letter-spacing: 0.05em;
}

.heroTitle {
	margin: 0;
	font-size: 1.05rem;
	font-weight: 700;
	color: $gray-700;
	line-height: 1.3;
}

.heroMetaGrid {
	margin-top: 12px;
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
}

.heroMetaItem {
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 8px 10px;
	border: 1px solid $gray-100;
	border-radius: 10px;
	background: rgba(255, 255, 255, 0.75);
}

.heroMetaLabel {
	font-size: 0.6875rem;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: $gray-500;
}

.heroMetaValue {
	font-size: 0.85rem;
	font-weight: 600;
	line-height: 1.3;
	color: $gray-700;
	word-break: break-word;
}

.tableCard {
	border: 1px solid $gray-200;
	border-radius: 12px;
	padding: 14px;
	background: #ffffff;
}

.table {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.875rem;
}

.headerRow {
	border-bottom: 1px solid $gray-200;
}

.headerCellLeft {
	padding: 8px;
	text-align: left;
	font-weight: 700;
	font-size: 0.75rem;
	color: $gray-700;
	background: $gray-50;
}

.headerCellRight {
	padding: 8px;
	text-align: right;
	font-weight: 700;
	font-size: 0.75rem;
	color: $gray-700;
	background: $gray-50;
}

.bodyRow {
	border-bottom: 1px solid $gray-50;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: rgba(127, 176, 47, 0.06);
	}
}

.cellLeft {
	padding: 8px;
}

.cellRight {
	padding: 8px;
	text-align: right;
}

.quantityInput {
	width: 100px;
	padding: 7px 9px;
	border: 1px solid $gray-200;
	border-radius: 10px;
	text-align: right;
	font-size: 0.875rem;
	transition:
		border-color 0.2s ease,
		box-shadow 0.2s ease;

	&:focus {
		outline: none;
		border-color: $primary-color;
		box-shadow: 0 0 0 3px rgba(130, 188, 68, 0.16);
	}
}

.emptyRow {
	padding: 24px;
	text-align: center;
	color: $gray-400;
}

.paginationRow {
	display: flex;
	gap: 8px;
	align-items: center;
	justify-content: flex-end;
}

.paginationText {
	font-size: 0.875rem;
	color: $gray-500;
}

@media (max-width: 768px) {
	.heroMetaGrid {
		grid-template-columns: 1fr;
	}

	.tableCard {
		padding: 10px;
		overflow-x: auto;
	}

	.table {
		min-width: 520px;
	}
}
